import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';

const RankingsHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const buttons = [
    { label: "🚀 Udyam Pragati", route: "/udyampragatiscore" },
    { label: "🏅 Shram Samman", route: "/sharmsammanscore" },
    { label: "🧠 YUVASolver", route: "/yuvasolverscore" },
    { label: "🏛️ GOVThinker", route: "/govthinkerscore" },
    { label: "👩‍💼 Healthy Citizen", route: "/healthycitizenscore" },
    { label: "🏡 Healthy Family", route: "/healthyfamilyscore" },
    { label: "💖 SAKSHAM Shakti", route: "/sakshamshaktiscore" },
    { label: "🤙 Golden7", route: "/golden7score" },
    { label: "🌾 SAKSHAM Farmer", route: "/sakshamfarmerscore" },
    { label: "🏘️ SAKSHAM Panchayat", route: "/sakshampanchayatscore" },
    { label: "🍽 SAKSHAM HORECA", route: "/sakshamhorecascore" },
    { label: "🌸 SHG", route: "/shgscore" },
    { label: "⚖️ LEGEND", route: "/legendscore" },
    { label: "🏏 Googly", route: "/googly-ranking" }, 
    { label: "🏦 BankWala", route: "/bankwalascore" },
    { label: "🌼 Bhakti", route: "/bhaktiscore" },            
    { label: "🤖 AI Users", route: "/aiuserscore" }
  ];

  return (
    <div className="min-h-screen font-sans text-gray-200 bg-black">
      <header className="flex justify-between items-center px-4 py-1 bg-black sticky top-0 z-50">
        <div className="text-lg sm:text-xl font-extrabold tracking-wide text-white cursor-pointer" onClick={() => navigate('/rankings')}>
          🏅 SAKSHAM Bharat Scorecards
        </div>
        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-yellow-300 text-xs lg:text-sm">{userName}</span>
              <button
                onClick={handleLogout}
                className="mt-4 w-8 h-8 flex items-center justify-center text-lg bg-red-600 text-white rounded-full hover:bg-red-700 transition shadow-lg"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-yellow-400 text-yellow-300 rounded-full hover:bg-yellow-500 hover:text-gray-900 transition"
              >
                Login
              </button>
            </>
          )}
        </div>

        <div className="md:hidden flex items-center">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden mt-2 w-12 h-10 flex items-center justify-center text-xl bg-purple-700 text-white"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-800 px-4 py-4 space-y-2 text-center shadow-lg rounded-b-lg">
          {isLoggedIn && (
            <div className="flex flex-col items-center text-yellow-300">
              <p className="text-xs lg:text-sm">{userName}</p>
              <button
                onClick={handleLogout}
                className="w-10 h-10 mt-4 flex items-center justify-center bg-red-600 text-white rounded-full hover:bg-red-700 transition"
              >
                ⏻
              </button>
            </div>
          )}
          {!isLoggedIn && (
            <div className="flex justify-center space-x-2 mt-2">
              <button className="px-4 py-2 text-sm border border-yellow-400 text-yellow-300 rounded-full hover:bg-yellow-500 hover:text-gray-900 transition">Login</button>
              <button className="px-4 py-2 text-sm bg-yellow-400 text-gray-900 rounded-full hover:bg-yellow-500 transition">Register</button>
            </div>
          )}
        </div>
      )}

      <nav className="flex justify-center items-center space-x-4 mt-2 py-2 border border-purple-400">
        <a href="/rankings-updates" className="hover:text-yellow-300 font-bold">Updates</a>
      </nav>

      <section className="relative bg-black py-4 px-2">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {buttons.map((btn, idx) => (
            <button
              key={idx}
              onClick={() => navigate(btn.route)}
              className="w-full py-2 px-2 text-xs lg:text-sm font-semibold bg-purple-800"
            >
              {btn.label}
            </button>
          ))}
        </div>
      </section>

      <section id="about" className="flex-1 justify-center py-2 px-4 bg-black">
        <h2 className="text-lg lg:text-xl font-bold text-center mb-2 text-yellow-400">About SAKSHAM Bharat Scorecards</h2>
        <div className="max-w-4xl mx-auto text-center text-gray-300 mb-4">
          <p className="text-sm lg:text-m text-gray-200 leading-relaxed">
            <strong>Bharat Scorecards</strong> is a transformative, national benchmarking framework that empowers India’s key growth drivers through data-driven insights and structured evaluation. 
            It evaluates MSMEs, Blue Collar Workers, students, government departments, citizens, families, Panchayats, and local micro-clusters, fostering excellence, accountability, and innovation. 
            Together, these eleven scorecards form a robust, inclusive, and visionary system to build an <strong>Atmanirbhar Bharat</strong>, unlocking potential and inspiring measurable impact across the nation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 place-items-center">
          {[
            {
              id: 1,
              title: "🚀 Udyam Pragati Scorecard",
              description: "A national/regional MSME ranking system empowering enterprises through literacy, productivity, and services.",
            },
            {
              id: 2,
              title: "🏅 Shram Samman Scorecard",
              description: "Profiles and rewards Blue Collar Workers, Subcontractors, and Employers aligned with Skill India.",
            },
            {
              id: 3,
              title: "🧠 YUVASolver Scorecard",
              description: "Promotes structured thinking and analytical problem-solving using Think5Whys and Lean Six Sigma microtools.",
            },
            {
              id: 4,
              title: "🏛️ GOVThinker Scorecard",
              description: "Ranks government officials to foster deep thinking and structured governance problem-solving.",
            },
            {
              id: 5,
              title: "👩‍💼 Healthy Citizen Scorecard",
              description: "Promotes preventive health, lifestyle awareness, and personal responsibility.",
            },
            {
              id: 6,
              title: "🏡 Healthy Family Scorecard",
              description: "Encourages family health practices, nutrition, wellness behavior, and intergenerational awareness.",
            },
            {
              id: 7,
              title: "💖 SAKSHAM Shakti Scorecard",
              description: "Ranks women on learning, self/family/home engagement, and community participation.",
            },
            {
              id: 8,
              title: "🤙 Golden7 Scorecard",
              description: "Ranks Teenagers / Young Adults on learning, self/family/home engagement, and community participation.",
            },
            {
              id: 9,
              title: "🌾 SAKSHAM Farmer Scorecard",
              description: "Empowers farmers with agri-literacy, smart techniques, digital enablement, and sustainability.",
            },
            {
              id: 10,
              title: "🏘️ SAKSHAM Panchayat Scorecard",
              description: "Performance index for Panchayats integrating governance, citizen engagement, and local innovation.",
            },
            {
              id: 11,
              title: "🍽 SAKSHAM HORECA Scorecard",
              description: "Hotel-Restaurant-Cafeteria ranking integrating governance, digital initiatives, and owner participation.",
            },
            {
              id: 12,
              title: "🌸 SAKSHAM Gat Scorecard",
              description: "Micro-cluster/community development ranking integrating social, economic, and sustainability metrics.",
            },
            {
              id: 13,
              title: "🏏 Googly Scorecard",
              description: "Cricket fan scorecard.",
            },
            {
              id: 14,
              title: "⚖️ LEGEND Scorecard",
              description: "Legal sector professionals scorecard.",
            },
            {
              id: 15,
              title: "🏦 Bankwala Scorecard",
              description: "BFSI Employee scorecard.",
            },
            {
              id: 16,
              title: "🌼 Bhakti Scorecard",
              description: "Religious followers scorecard.",
            },
            {
              id: 17,
              title: "🤖 AI Users Scorecard",
              description: "AI User / AI Quotient scorecard.",           
            }
          ].map(card => (
            <div
              key={card.id}
              className="bg-black border border-purple-500 hover:bg-gray-700 transition rounded-xl shadow-lg hover:shadow-2xl overflow-hidden p-4 flex flex-col justify-between w-full"
            >
              <h3 className="text-sm lg:text-m font-semibold text-yellow-300 mb-4">{card.title}</h3>
              <p className="text-gray-300 text-xs lg:text-sm">{card.description}</p>
            </div>
          ))}
        </div>
      </section>

      <footer className="sticky bg-black border-t border-purple-400 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
};

export default RankingsHome;
